import { Dialog } from "@dash/dialog";
import { Button } from "@dash/form";
import { useTheme } from "@emotion/react";
import React from "react";
import { MdDeleteOutline } from "react-icons/md";
import { useNavigate } from "react-router-dom-v5-compat";

import { Report } from "@megaron/crm-contracts";
import { getMegaraxPath } from "@megaron/megarax-uri";
import { useClientManager } from "@megaron/react-clients";

export const RemoveReportDialog: React.FC<{ report: Report; onClose: () => void }> = ({ report, onClose }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const remove = useClientManager("crm")
    .removeReport()
    .useMutation({
      onSuccess: async (_, __, { queryClient }) => {
        await queryClient.invalidateQueries(["crm", "reportsQuery"]);
        navigate(getMegaraxPath.uri("megarax://crm/reports"), { replace: true });
      },
    });

  return (
    <Dialog onClose={onClose} placement="center" css={{ width: "400px" }} hideHeader>
      <div css={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <span css={{ fontSize: "1rem", color: theme.colors.danger, fontWeight: 700 }}>Usuń raport</span>
        <span css={{ fontSize: "0.875rem", color: "black" }}>
          Czy na pewno chcesz usunąć raport „{report.title}”? Tej operacji nie można cofnąć.
        </span>
        {remove.isError && (
          <span css={{ fontSize: "0.75rem", color: theme.colors.danger }}>Nie udało się usunąć raportu</span>
        )}
        <div css={{ display: "flex", gap: "0.625rem", marginLeft: "auto" }}>
          <Button variant="outline" onClick={onClose}>
            Anuluj
          </Button>
          <Button
            icon={<MdDeleteOutline />}
            css={{ background: theme.colors.danger }}
            onClick={() => remove.mutate({ uuid: report.uuid })}
            isLoading={remove.isLoading}
          >
            Usuń
          </Button>
        </div>
      </div>
    </Dialog>
  );
};
